<template>
  <el-dialog
    fullscreen
    :visible="isShow"
    :modal="false"
    :show-close="false"
    custom-class="dialog-form"
  >
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 打印票据</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <div class="form-container" style="top:10px">
      <el-form ref="form" :model="formData" size="mini" label-width="80px">
        <div class="form-main">
          <el-row>
            <el-col :span="6">
              <el-form-item label="笼号" required>
                <el-input
                  v-if="formStatus"
                  placeholder="笼号"
                  v-model="formData.basketNo"
                ></el-input>
                <span v-else>{{ formData.basketNo }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="开始日期" required>
                <el-date-picker
                  v-if="formStatus"
                  value-format="yyyy-MM-dd"
                  type="date"
                  size="mini"
                  placeholder="选择日期"
                  clearable
                  v-model="formData.start_date"
                ></el-date-picker>
                <span v-else>{{ formData.start_date }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="结束日期" required>
                <el-date-picker
                  v-if="formStatus"
                  value-format="yyyy-MM-dd"
                  type="date"
                  size="mini"
                  placeholder="选择日期"
                  clearable
                  v-model="formData.end_date"
                ></el-date-picker>
                <span v-else>{{ formData.end_date }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                v-if="formStatus"
                icon="el-icon-search"
                type="primary"
                size="mini"
                @click="searchHandler"
                >搜索</el-button
              >
            </el-col>
          </el-row>
        </div>
        <div class="detail-header">
          <div class="detail-title">
            <i class="em-icon-th-list"></i> 包装票据明细
          </div>
          <el-button
            v-if="formData.details.length > 0"
            type="success"
            size="mini"
            icon="el-icon-printer"
            round
            @click="printHandler"
            >打印票据</el-button
          >
        </div>
        <div class="el-table-container form-details" style="top: 66px;">
          <div style="height: 100%;">
            <el-table
              :data="formData.details"
              size="mini"
              height="100%"
              style="width: 100%; border:1px solid #d1d1d1;"
              border
              header-row-class-name="list-header-row"
            >
              <el-table-column
                label="日期"
                prop="attendanceDate"
                width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                label="样本册名称"
                prop="sampleName"
                width="200"
                align="center"
              ></el-table-column>
              <el-table-column
                label="担当"
                prop="undertake"
                width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                label="页码"
                prop="pageCount"
                width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                label="分期"
                prop="fristBack"
                width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                label="品番"
                prop="merchandiseNumber"
                width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                label="单位"
                prop="bagNum"
                width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                label="单位1"
                prop="unit1"
                width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                label="数量"
                prop="packageNum"
                width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                label="单位2"
                prop="unit2"
                width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                label="包装产量"
                prop="productOutput"
                width="100"
                align="center"
              ></el-table-column>
              <el-table-column></el-table-column>
            </el-table>
          </div>
        </div>
      </el-form>
    </div>
    <div
      id="print_area"
      style="position: relative; z-index: -1;text-align:center"
    >
      <div style="font-size:30pt">板块票</div>
      <div ref="codeItem" style="margin-top:10px"></div>
      <div style="margin-top:10px;font-size:35pt;font-weight: bold;">
        <span>样本册：</span
        ><span>{{
          arrayPrint.sampleName
        }}</span>
      </div>
      <div style="margin-top:10px;font-size:35pt;font-weight: bold;">
        <span >笼号：</span
        ><span >{{ arrayPrint.basketNo }}</span>
      </div>
      <div style="margin-top:10px;font-size:20pt;width:627px;font-weight: bold;display:flex;flex-direction: row;justify-content:space-between;">
        <span >开始日期：</span><span >{{ formData.start_date }}</span>
        <span >结束日期：</span><span >{{ formData.end_date }}</span>
      </div>
      <div v-for="(item, index) in arrayPrint.details" :key="index">
        <div style="margin-top:10px;font-size:22pt">
          <span style="float:left;width:139px;border:1px solid #000;"
            >日期：</span
          ><span style="float:left;width:489px;border:1px solid #000;">{{
            item.attendanceDate
          }}</span>
        </div>
        <table
          border="1px solid #000"
          cellspacing="0"
          style="table-layout: fixed"
        >
        <thead>
          <tr>
            <th style="width:66px">页码</th>
            <th style="width:66px">担当</th>
            <th style="width:66px">分期</th>
            <th style="width:66px">品番</th>
            <th style="width:66px">单位</th>
            <th style="width:66px">单位1</th>
            <th style="width:66px">数量</th>
            <th style="width:66px">单位2</th>
            <th style="width:66px">包装产量</th>
          </tr>
          </thead>
          <template v-for="(itemSub, indexSub) in item">
            <tr :key="indexSub" v-if="itemSub != null && itemSub.pageCount">
              <td>{{ itemSub.pageCount }}</td>
              <td>{{ itemSub.undertake }}</td>
              <td>{{ itemSub.fristBack }}</td>
              <td>{{ itemSub.merchandiseNumber }}</td>
              <td>{{ itemSub.bagNum }}</td>
              <td>{{ itemSub.unit1 }}</td>
              <td>{{ itemSub.packageNum }}</td>
              <td>{{ itemSub.unit2 }}</td>
              <td>{{ itemSub.productOutput }}</td>
            </tr>
          </template>
        </table>
      </div>
    </div>
  </el-dialog>
</template>
<style>
.el-table .warning-row {
  background: #ffaa96;
}
</style>
<script>
import QRCode from 'qrcodejs2'
export default {
  name: 'EzzDialogForm',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      // 当前子组件对话框的显隐
      isShow: false,
      formData: null,
      formEmptyData: {
        id: '0',
        basketNo: '',
        start_date: '',
        end_date: this.currentDate,
        details: [],
        creater_name: sessionStorage.getItem('operator'),
        creater_id: sessionStorage.getItem('operator_id'),
        create_time: ''
      },
      operator_id: sessionStorage.getItem('operator_id'),
      formStatus: false,
      arrayPrint: {
        sampleName: '',
        basketNo: '',
        details: []
      }
    }
  },
  beforeCreate: function () {
    var date = new Date()
    var month =
      date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var day = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()
    var hours = date.getHours() <= 9 ? '0' + date.getHours() : date.getHours()
    var mins =
      date.getMinutes() <= 9 ? '0' + date.getMinutes() : date.getMinutes()
    this.currentDate = date.getFullYear() + '-' + month + '-' + day
    this.currentTime =
      date.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + mins
  },
  created: function () {
    this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
  },
  mounted: function () {},
  methods: {
    // 加载数据
    loadData: function () {
      let _this = this
      _this.formData.operator_id = _this.operator_id
      _this.post(_this.$apis.getPackageDetail, _this.formData, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          // 判断样本册是否都是一个
          let bol = true
          for (let i = 0; i < _json.datalist.length; i++) {
            if (
              i + 1 < _json.datalist.length &&
              _json.datalist[i].sampleName !== _json.datalist[i + 1].sampleName
            ) {
              bol = false
            }
          }
          if (bol) {
            if (_json.mainlist !== null) {
              _this.formData.basketNo = _json.mainlist.basketNo
              _this.formData.start_date = _json.mainlist.start_date
              _this.formData.end_date = _json.mainlist.end_date
            }
            _this.formData.details = _json.datalist
            // 重新设计打印数据架构
            _this.arrayPrint = {
              sampleName: '',
              basketNo: '',
              details: []
            }
            if (_this.formData.details.length > 0) {
              _this.arrayPrint.sampleName =
                _this.formData.details[0].sampleName
              _this.arrayPrint.basketNo = _this.formData.details[0].basketNo
              var splitList = _this._.groupBy(_json.datalist, function (obj) {
                return obj['attendanceDate']
              })
              for (
                let j = 0;
                j < Object.getOwnPropertyNames(splitList).length;
                j++
              ) {
                _this.arrayPrint.details.push(Object.values(splitList)[j])
                _this.arrayPrint.details = _this.arrayPrint.details.map(
                  row => ({
                    ...row,
                    attendanceDate: row[0].attendanceDate,
                    undertake: row[0].undertake
                  })
                )
              }
            }
          } else {
            _this.$message({
              type: 'info',
              message: '当前日期包含多个样本册信息，请重新选择日期。'
            })
          }
        }
      })
    },
    close: function () {
      this.$confirm('确定关闭？', '提示', {})
        .then(_ => {
          this.isShow = false
        })
        .catch(_ => {
          return false
        })
    },
    searchHandler: function () {
      let _this = this
      if (_this.formData.basketNo === '') {
        _this.$message({
          type: 'error',
          message: '笼号不能为空'
        })
        return false
      } else if (_this.formData.start_date === '') {
        _this.$message({
          type: 'error',
          message: '开始日期不能为空'
        })
        return false
      } else if (_this.formData.end_date === '') {
        _this.$message({
          type: 'error',
          message: '结束日期不能为空'
        })
        return false
      } else {
        _this.loadData()
      }
    },
    printHandler: function () {
      let _this = this
      _this.$refs.codeItem.innerHTML = ''

      // // 先判断当前查询笼号是否在用
      // _this.post(_this.$apis.getStoreIsUse, _this.formData, function (
      //   res
      // ) {
      //   let _json = res.data
      //   if(_json&&_json.isUse)
      //   {
      //     _this.$message({
      //       type: 'error',
      //       message: '对不起，当前笼号在用，无法打印！'
      //     })
      //     return false;
      //   }
      //   else{
      
      //   }
      // })

          
      // 先判断当前查询数据在不在新数据库中，如果不在插入新数据库。
      _this.post(_this.$apis.getPackageCollectionId, _this.formData, function (
        res
      ) {
        let _json = res.data
        new QRCode(_this.$refs.codeItem, {
          // 二维码内容
          text: 'L,' + _this.formData.basketNo + ',' + _json.id,
          width: 300,
          height: 300,
          // 二维码颜色
          colorDark: '#333333',
          // 二维码背景色
          colorLight: '#ffffff'
        })
        setTimeout(() => {
          const style =
            '@page { margin-top: 50px } @media print { h1 { color: blue } img {margin: 0 auto;}}'
          _this.$print({
            printable: 'print_area',
            type: 'html',
            style: style,
            scanStyles: false
          })
        }, 200)
        _this.parent.loadData()
      })

    },
    addHandler: function () {
      this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
      this.formData.id = '0'
      this.isShow = true
      this.formStatus = true
    },
    viewHandler: function (formId) {
      this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
      this.formData.id = formId
      this.loadData()
      this.isShow = true
      this.formStatus = false
    }
  },
  components: {}
}
</script>
